export default "__VITE_ASSET__D6UWNW3x__"